import axios from "axios";
import React, { useEffect, useState } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import BreadcrumbScroll from "../../components/Elements/BreadcrumbScroll/BreadcrumbScroll";
import Head from "next/head";
import ServerError from "../../components/Elements/ServerError/ServerError";
import FilterList from "../../components/Elements/FilterList/FilterList";
import HeaderCards from "../../components/Elements/HeaderCards/HeaderCards";
import {
  newsThumbnailsDeserializer,
  singleNewsDataDeserializer,
} from "../../components/Services/deserializer";
// import Info from './Info'

const Index = ({ initialProps, metaData: jsonMetaData, catData }) => {
  const { cat, search, page } = JSON.parse(initialProps);
  const metaData = jsonMetaData !== null ? JSON.parse(jsonMetaData) : null;
  const [finalCat, setFinalCat] = useState([]);
  const [data, setData] = useState([]);
  const [loadingPosts, setLoadingPosts] = useState(false);
  const [paramLoaded, setParamLoaded] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [activeSearch, setActiveSearch] = useState("");
  const [notResultFound, setNotResulteFound] = useState(false);
  const [conectionError, setConectionError] = useState(false);
  const [pageNeedsRefresh, setPageNeedsRefresh] = useState(false);

  useEffect(() => {
    if (!paramLoaded) {
      // cat?.length > 0 && setFinalCat([...finalCat, ...cat.split(",")]);
      cat?.length > 0 && setFinalCat(cat);
      search?.length > 0 && setActiveSearch(search);
      page?.length > 0 && setActivePage(Number(page));
      setParamLoaded(true);
    }
  }, [cat, finalCat, page, search, paramLoaded]);

  useEffect(() => {
    setPageNeedsRefresh(true);
    setActivePage(1);
  }, [finalCat, activeSearch]);

  useEffect(() => {
    if (paramLoaded) {
      let urlAddedPart = {};
      urlAddedPart.page = String(activePage);
      if (finalCat.length > 0) {
        urlAddedPart.categories = String(finalCat);
      }
      if (activeSearch.length > 0) {
        urlAddedPart.search = String(activeSearch);
      }
      setLoadingPosts(true);
      const counter = setTimeout(() => {
        getNewsRequest(urlAddedPart);
      }, 1000);
      return () => clearTimeout(counter);
    }
  }, [activePage, pageNeedsRefresh, paramLoaded, activeSearch, finalCat]);

  const getNewsRequest = (urlAddedPart) => {
    axios
      .get(
        "https://about.digikala.com/wp-json/wp/v2/posts?_embed&status=publish&per_page=6&language=fa",
        {
          params: { ...urlAddedPart, rt: Date.now() },
        }
      )
      .then((res) => {
        setLoadingPosts(false);
        if (res.data.length === 0) {
          setData([]);
          setNotResulteFound(true);
          setTotalPage(0);
        } else {
          const filteredData = res.data.filter(item => (item.id !== 1010574)).map((item) => newsThumbnailsDeserializer(item));
          setData(filteredData);
          setNotResulteFound(false);
          setTotalPage(Math.ceil(parseInt(res.headers.get("x-wp-total") / 6)));
        }
        setConectionError(false);
      })
      .catch((err) => {
        console.log(err);
        setLoadingPosts(false);
        setTotalPage(0);
        setConectionError(true);
      });
  };

  return (
    <>
      {metaData && (
        <>
          <Head>
            <title>اتاق خبر دیجی‌کالا - درباره گروه دیجی‌کالا</title>
            <meta
              name="viewport"
              content="initial-scale=1.0, width=device-width, maximum-scale=1"
            />
            <meta charSet="utf-8" />
            <meta
              name="description"
              content="تازه‌ترین خبرهای دیجی‌کالا، اطلاع‌رسانی‌ها، بیانیه‌های مطبوعاتی، مسئولیت‌های اجتماعی، رویدادها و گزارش‌های دیجی‌کالا را اینجا بخوانید."
            />
            <link rel="icon" type="image/x-icon" href="/faviconNew.svg"></link>
            <meta
              name="robots"
              content="index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
            />
            <link
              rel="canonical"
              href={`https://about.digikala.com/newsroom/`}
            />
            <meta property="og:locale" content="fa_IR" />
            <meta property="og:type" content="website" />
            <meta
              property="og:title"
              content="اتاق خبر دیجی‌کالا - درباره گروه دیجی‌کالا"
            />
            <meta
              property="og:url"
              content={`https://about.digikala.com/newsroom/`}
            />
            <meta property="og:site_name" content="درباره گروه دیجی‌کالا" />
            <meta property="og:image" itemProp="image" content="/ogImage.jpg" />
            <meta property="og:image:width" content="500" />
            <meta property="og:image:height" content="500" />
            <meta
              property="og:image:alt"
              content="اتاق خبر دیجی‌کالا - درباره گروه دیجی‌کالا"
            />
            <meta property="og:image:type" content="image/png" />
            <meta
              property="og:site_name"
              content="اتاق خبر دیجی‌کالا"
              key="ogsitename"
            />
            <meta
              property="og:title"
              content="اتاق خبر دیجی‌کالا - درباره گروه دیجی‌کالا"
              key="ogtitle"
            />
            <meta
              property="og:description"
              content="تازه‌ترین خبرهای دیجی‌کالا، اطلاع‌رسانی‌ها، بیانیه‌های مطبوعاتی، مسئولیت‌های اجتماعی، رویدادها و گزارش‌های دیجی‌کالا را اینجا بخوانید."
              key="ogdesc"
            />
            <meta name="twitter:card" content="summary_large_image" />
            <meta
              name="twitter:title"
              content="اتاق خبر دیجی‌کالا - درباره گروه دیجی‌کالا"
            />
            <meta name="twitter:site" content="درباره گروه دیجی‌کالا" />
            <meta
              name="twitter:image"
              content="https://about.digikala.com/ogImage.jpg"
            />
            <meta
              name="twitter:description"
              content="تازه‌ترین خبرهای دیجی‌کالا، اطلاع‌رسانی‌ها، بیانیه‌های مطبوعاتی، مسئولیت‌های اجتماعی، رویدادها و گزارش‌های دیجی‌کالا را اینجا بخوانید."
            />
          </Head>
        </>
      )}
      {!metaData && <ServerError prevPageLink="/" />}

      <BreadcrumbScroll
        title="اتاق خبر"
        routeOne="/newsroom/"
        titleOne="اتاق خبر"
      />
      <div className="spacerForbreadCrumb d-flex w-100"></div>
      {!conectionError ? (
        <>
          {/* {metaData?.length > 0 && (
            <HeaderCards
              headerTitle="مهم‌ترین خبر"
              data={
                metaData?.length > 0
                  ? metaData.map((item) => ({
                      title: item.title,
                      img: item.image,
                      imgAlt: item.title,
                      cat: item.category.name,
                      date: item.date,
                      link: `/newsroom/${item.slug}`,
                    }))
                  : []
              }
            />
          )} */}

          {/* INFO SECTION  */}

          {/* <Info /> */}

          {/*  */}
          <FilterList
            activeSearch={activeSearch}
            setActiveSearch={setActiveSearch}
            catList={
              JSON.parse(catData)?.length > 0
                ? JSON.parse(catData).map((item) => ({
                    id: item.id,
                    title: item.name,
                  }))
                : []
            }
            finalCat={finalCat}
            setFinalCat={setFinalCat}
            notResultFound={notResultFound}
            loadingPosts={loadingPosts}
            data={
              data?.length > 0
                ? data?.map((item) => ({
                    id: item.id,
                    img: item.img,
                    imgAlt: item.imgAlt,
                    title: item.title,
                    cat: item.catTitle,
                    date: item.date,
                    slug: item.slug,
                    duration: item.duration,
                    link: item.link,
                  }))
                : []
            }
            totalPage={totalPage}
            activePage={activePage}
            setActivePage={setActivePage}
            pageNeedsRefresh={pageNeedsRefresh}
            setPageNeedsRefresh={setPageNeedsRefresh}
            catTitle="خبرها"
          />
        </>
      ) : (
        <ServerError />
      )}
    </>
  );
};

export default Index;

export async function getServerSideProps({ query }) {
  const { cat } = query;
  const { search } = query;
  const { page } = query;
  try {
    // header content
    const recommendedNewsRes = await fetch(
      `${
        process.env.NEWSROOM_API_BASE_URL
      }/wp-json/wp/v2/posts/?_embed&status=publish&per_page=3&&_fields=id,date,title,excerpt,slug,categories,_links.wp:term,_links.wp:featuredmedia,_embedded.wp:term,_embedded.wp:featuredmedia&reqDate=${Date.now()}&is_published=true&language=fa`
    );
    const recommendedNewsData = await recommendedNewsRes.json();
    const refactoredNewsData = recommendedNewsData.map((item) =>
      singleNewsDataDeserializer(item)
    );
    // end of header content

    const categories = await fetch(
      `${
        process.env.NEWSROOM_API_BASE_URL
      }/wp-json/wp/v2/categories?_fields=id,name&lang=fa&reqDate=${Date.now()}&is_published=true&language=fa`
    );
    const categoriesData = await categories.json();
    return {
      props: {
        initialProps: JSON.stringify({ cat, search, page }),
        metaData: JSON.stringify(refactoredNewsData),
        // metaData: JSON.stringify(recommendedNewsData),
        catData: JSON.stringify(categoriesData),
      },
    };
  } catch (error) {
    return {
      props: {
        initialProps: JSON.stringify({ cat, search, page }),
        metaData: null,
        catData: null,
      },
    };
  }
}
